import { Decimal } from 'decimal.js'

/**
 * Money arithmetic shared by the API (authoritative) and the web app (previews). Amounts are
 * decimal strings; binary floating point never touches them. Rounding is half away from zero to
 * the baisa (3 decimal places) — commercial rounding.
 */
const D = Decimal.clone({ precision: 40, rounding: Decimal.ROUND_HALF_UP })

export type MoneyValue = string | number | Decimal

export function money(value: MoneyValue): Decimal {
  return new D(value)
}

/** Rounds to 3 dp and formats as a plain decimal string ("12.500"). */
export function toMoney(value: MoneyValue): string {
  return new D(value).toDecimalPlaces(3, D.ROUND_HALF_UP).toFixed(3)
}

export function sumMoney(values: Iterable<MoneyValue>): string {
  let total = new D(0)
  for (const v of values) total = total.plus(v)
  return toMoney(total)
}

export function isZero(value: MoneyValue): boolean {
  return new D(value).isZero()
}

export function compareMoney(a: MoneyValue, b: MoneyValue): -1 | 0 | 1 {
  return new D(a).comparedTo(b) as -1 | 0 | 1
}

/** True when the value has at most 3 decimal places (no rounding would be needed). */
export function hasMoneyScale(value: MoneyValue): boolean {
  return new D(value).decimalPlaces() <= 3
}
